import React from "react";
import "./landing.css";

export default function AboutUs() {
  return (
    <section className="tfm-section tfm-section--paper" id="aboutus">
      <div className="tfm-container tfm-about__grid">
        <div>
          <p className="tfm-eyebrow">About us</p>
          <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
            A wholesale market that takes orders the way you work.
          </h2>

          <div className="tfm-prose" style={{ marginTop: "1.6rem" }}>
            <p>
              Tripoli Fresh Market is a wholesale business based in the heart of
              Tripoli&rsquo;s municipal fresh market. We supply restaurants,
              hotels and vegetable shops, and we built an online ordering
              platform so buying from the market no longer means being on the
              floor at dawn.
            </p>
            <p>
              The platform comes out of years of market research and a close
              understanding of how wholesale ordering actually runs — the
              revisions, the approvals, the day&rsquo;s prices. It was developed
              by Arco Energies LLC, a business solutions and software
              development company.
            </p>
          </div>

          <p className="tfm-about__note">
            Chefs and purchasing managers order for their own kitchen; our team
            reviews every order before it goes out for delivery.
          </p>
        </div>

        <figure className="tfm-about__figure">
          <img
            src="/images/qualityAssured.png"
            alt="A crate packed with mixed fruit and vegetables"
            loading="lazy"
            width="500"
            height="500"
          />
        </figure>
      </div>
    </section>
  );
}
